import styled from 'styled-components'

export const DropdownItemWrapper = styled.div`
  display: flex;
  align-items: center;

  padding: 8px 20px;

  font-weight: 300;
  font-size: 16px;
  color: ${({ theme, disabled }) => (disabled ? theme.colors.brand : theme.colors.primary)};

  transition: 0.3s;
  cursor: pointer;

  & svg {
    max-width: 20px;
  }
  & svg > path {
    stroke: ${({ theme }) => theme.colors.primary};
  }
  & svg > ellipse {
    fill: ${({ theme }) => theme.colors.primary};
  }
  & svg > circle {
    stroke: ${({ theme }) => theme.colors.primary};
  }
  & svg > rect {
    stroke: ${({ theme }) => theme.colors.primary};
  }
  &:not(:last-child) {
    border-bottom: 2px solid ${({ theme }) => theme.colors.backgroundLite};
  }
  &:first-child {
    border-radius: 7px 7px 0 0;
  }
  &:last-child {
    border-radius: 0 0 7px 7px;
  }
  &:only-child {
    border-radius: 7px;
  }

  &:hover {
    background-color: ${({ theme, disabled }) => !disabled && theme.colors.backgroundLite};
  }

  &:focus {
    background-color: unset;
    color: inherit;
  }

  cursor: ${({ disabled }) => disabled && 'not-allowed'};

  & p {
    color: ${({ theme, disabled }) => (disabled ? theme.colors.secondary : theme.colors.primary)};
  }
  & a {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 200px;

    padding: 5px 0px;
    font-size: 15px;
    font-weight: 400;
    color: ${({ theme, disabled }) => (disabled ? theme.colors.secondary : theme.colors.primary)};

    & > svg {
      height: 12px;
      width: 12px;
    }
  }
`
